export const mergeFilter = (localFilter, pathFilter)=> {
    if (!localFilter && !pathFilter) return '';
    if (!localFilter) return pathFilter;
    if (!pathFilter) return localFilter;
    return `(${localFilter}) and (${pathFilter})`;
}

export const getOptions = (options, filter, data)=> {
    if (!options) return [];
    if(options instanceof Array) return options;
    if (filter) {
        filter = filter.replace(/\{([\w]+)\}/, ($0, $1)=> {
            let v = data[$1];
            if (v != null) v = JSON.stringify(v);
            return v || '""';
        })
        // console.log(filter,options);
    }
    return options.dataInfo.getFilteredOptions(filter, options.nameField, options.keyField);
}

export const getDynamicOptions = (options, filter, data, datas)=> {
    if (!options) return datas;
    if (datas != null && !(datas instanceof Array)) datas = [datas];
    if (filter) {
        filter = filter.replace(/\{([\w]+)\}/, ($0, $1)=> {
            let v = data[$1];
            if (v != null) v = JSON.stringify(v);
            return v || '""';
        })
        console.log(filter);
    }
    return options.dataInfo.getFilteredOptions(filter, options.nameField, options.keyField, datas);
}